<template>
  <div>
    <el-dialog
      :visible="detailDialogVisible"
      title="修改"
      width="800px"
      @close="closeDialog"
    >
      <el-form :model="subForm" ref="currentForm" :rules="rules" label-width="100px">
        <el-form-item label="币种：" prop="coinType">
          <el-select v-model="subForm.coinType" filterable placeholder="请选择(可搜索)">
            <el-option
              v-for="item in coinList"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期：" prop="rateDate">
          <el-date-picker type="date" placeholder="选择日期" v-model="subForm.rateDate"></el-date-picker>
        </el-form-item>
        <el-form-item label="年利率：" prop="yearRate">
          <el-input-number v-model="subForm.yearRate" :min="0"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog()">取消</el-button>
        <el-button type="primary" @click="handleSave('currentForm')">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  name: 'CurrentDetail',
  props: ['current'],
  data() {
    return {
      dialogVisible: false,
      subForm: {},
      rules: {
        coinType: [{ required: true, message: '币种不能为空！' }],
        rateDate: [{ required: true, message: '日期不能为空！' }],
        yearRate: [{ required: true, message: '年利率不能为空！' }]
      }
    };
  },
  computed: {
    ...mapState('currentSetting', ['coinList', 'detailDialogVisible'])
  },
  methods: {
    ...mapActions('currentSetting', ['update', 'list']),
    ...mapMutations('currentSetting', ['toggleDetailDialogVisible']),
    addItem() {
      this.current.push({});
    },
    closeDialog() {
      this.toggleDetailDialogVisible(false);
      this.$refs['currentForm'].resetFields();
    },
    handleSave(formName) {
      let _this = this;
      _this.$refs['currentForm'].validate(valid => {
        if(valid) {
          let reqData = {
            id: this.current.id,
            coinType: this.subForm.coinType,
            rateDate: (this.subForm.rateDate && this.subForm.rateDate.getTime && this.subForm.rateDate.getTime()) || this.subForm.rateDate,
            yearRate: this.subForm.yearRate
          };
          this.update(reqData).then(() => {
            this.$message.success('修改成功！');
            this.toggleDetailDialogVisible(false);
            this.list({});
          });
        }
      });
    }
  },
  watch: {
    current(newVal,oldVal) {
      this.subForm = {...newVal};
    }
  }
};
</script>

<style lang="less" scoped>
.add-wrap {
  margin: 10px 30px;
}
.editor {
  height: 500px;
}
.val-input {
  width: 200px;
}
</style>
